import { request } from "../axios";
import { handleApiError } from "../helper";
import { KEYS } from "./keys";
import { IClientLocationResponse, ITrackWalletLocationEventPayload, IWalletLocationEventResponse } from "./types";

/**
 * Returns only the server-resolved country code for automatic locale selection.
 * It is intentionally public so first-time visitors do not need a wallet session.
 */
export async function getClientLocation(): Promise<IClientLocationResponse> {
  try {
    const { data } = await request.get(KEYS.CLIENT_LOCATION, { timeout: 2000 });
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function trackWalletLocationEvent(
  payload: ITrackWalletLocationEventPayload
): Promise<IWalletLocationEventResponse> {
  try {
    const { data } = await request.post(KEYS.WALLET_LOCATION_EVENTS, payload);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
